module.exports = __webpack_public_path__ + "static/media/prod-feature.eb975719.png";